import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div className="mb-8">
    <h2 className="font-heading text-xl font-bold mb-3 text-foreground">{title}</h2>
    <div className="text-muted-foreground text-sm leading-relaxed space-y-2">{children}</div>
  </div>
);

const DisclaimerPage = () => (
  <>
    <Helmet>
      <title>Disclaimer | Debnath Telecom</title>
      <meta name="description" content="Disclaimer for Debnath Telecom & Variety Store — debnathtelecom.in" />
    </Helmet>

    <div className="container max-w-3xl py-12 px-4">
      <div className="mb-8">
        <p className="text-xs text-muted-foreground uppercase tracking-widest mb-2">Legal</p>
        <h1 className="font-heading text-3xl md:text-4xl font-extrabold mb-2">Disclaimer</h1>
        <p className="text-sm text-muted-foreground">Last updated: April 2025 &nbsp;|&nbsp; <a href="https://debnathtelecom.in" className="text-primary hover:underline">debnathtelecom.in</a></p>
      </div>

      <div className="prose-sm max-w-none">
        <Section title="1. General Information">
          <p>The information provided on <strong>debnathtelecom.in</strong> (the "Website") is for general informational purposes only. Debnath Telecom & Variety Store makes no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, or availability of the information, products, or services on the Website.</p>
        </Section>

        <Section title="2. Product Information">
          <p>We strive to display accurate product descriptions, specifications, and pricing. However:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Product images are for illustrative purposes and may slightly differ from the actual product</li>
            <li>Prices are subject to change without prior notice</li>
            <li>Product availability is subject to stock and may vary</li>
            <li>Specifications are sourced from manufacturers and may be updated without notice</li>
          </ul>
        </Section>

        <Section title="3. Authorized Dealer">
          <p>Debnath Telecom is an authorized dealer of the brands listed on our website. All products sold are genuine and come with valid manufacturer warranty. We are not the manufacturer of any product and are not responsible for manufacturer defects beyond the warranty terms provided.</p>
        </Section>

        <Section title="4. Pricing Disclaimer">
          <p>All prices displayed on the website are in Indian Rupees (₹) and are inclusive of applicable taxes unless stated otherwise. We reserve the right to modify prices at any time. In the event of a pricing error, we reserve the right to cancel orders placed at incorrect prices and will notify affected customers promptly.</p>
        </Section>

        <Section title="5. Warranty & Returns">
          <p>Warranty terms are governed by the respective product manufacturer. Debnath Telecom facilitates warranty claims but is not directly responsible for manufacturer warranty decisions. Our return and replacement policy applies only to manufacturing defects reported within 7 days of delivery.</p>
        </Section>

        <Section title="6. External Links">
          <p>Our website may contain links to external websites for your convenience. These links do not constitute an endorsement of those websites. We have no control over the content of external sites and accept no responsibility for them.</p>
        </Section>

        <Section title="7. Limitation of Liability">
          <p>To the fullest extent permitted by law, Debnath Telecom shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our website or products purchased through it. Our total liability shall not exceed the amount paid for the specific product in question.</p>
        </Section>

        <Section title="8. Governing Law">
          <p>This disclaimer is governed by the laws of India. Any disputes arising in connection with this disclaimer shall be subject to the exclusive jurisdiction of the courts in West Bengal, India.</p>
        </Section>

        <Section title="9. Contact Us">
          <p>For any questions regarding this disclaimer, please contact us:</p>
          <ul className="list-none space-y-1">
            <li>📧 <a href="mailto:chinmaydebnath21@gmail.com" className="text-primary hover:underline">chinmaydebnath21@gmail.com</a></li>
            <li>📞 +91 96792 00493</li>
            <li>🌐 <a href="https://debnathtelecom.in" className="text-primary hover:underline">debnathtelecom.in</a></li>
            <li>📍 Kharagpur City Road, Baga Bhera, West Bengal, Pin 721437, India</li>
          </ul>
        </Section>
      </div>

      <div className="mt-10 pt-6 border-t text-sm text-muted-foreground">
        <Link to="/" className="text-primary hover:underline">← Back to Home</Link>
        <span className="mx-3">|</span>
        <Link to="/privacy-policy" className="text-primary hover:underline">Privacy Policy</Link>
      </div>
    </div>
  </>
);

export default DisclaimerPage;
